import { render, staticRenderFns } from "./LayoutHome.vue?vue&type=template&id=2d67f0fa&scoped=true&"
import script from "./LayoutHome.vue?vue&type=script&lang=js&"
export * from "./LayoutHome.vue?vue&type=script&lang=js&"
import style1 from "./LayoutHome.vue?vue&type=style&index=1&id=2d67f0fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67f0fa",
  null
  
)

export default component.exports